import { BadgeDotSize } from './enums';
import { badgeDotFills } from './brandColors';
import { ShapeType, SvgSpriteIcon, SvgSpriteIconProps } from '@ardoq/icons';
import { StatusType } from '../types';

type BadgeDotProperties = Omit<SvgSpriteIconProps, 'symbolName' | 'color'> & {
  size: BadgeDotSize;
  color: StatusType;
};

export const BadgeDot = ({
  size,
  color,
  style,
  ...rest
}: BadgeDotProperties) => {
  const badgeDotColor = badgeDotFills[color];
  const iconStyle = {
    ...style,
    height: size,
    width: size,
    minHeight: size,
    minWidth: size,
    color: badgeDotColor,
    fill: badgeDotColor,
  };
  return (
    <SvgSpriteIcon
      symbolName={ShapeType.CIRCLE}
      style={iconStyle}
      height={size}
      width={size}
      {...rest}
    />
  );
};
